export default {
	title: 'Gestión de Tipos de Sensor',
	actions: {
		add: 'Agregar',
		edit: 'Editar',
		delete: 'Eliminar',
		batchDelete: 'Eliminar por Lote'
	},
	messages: {
		deleteConfirm: '¿Está seguro de que desea eliminar {count} registro(s) seleccionado(s)?',
		deleteSuccess: 'Operación exitosa',
		selectDeleteWarning: 'Por favor seleccione el registro a eliminar',
		operateSuccess: 'Operación exitosa',
		requiredFieldCannotBeEmpty: 'El campo obligatorio no puede estar vacío'
	},
	form: {
		name: 'Nombre del Tipo',
		axisCount: 'Cantidad de Ejes',
		upMode: 'Modo Ascendente',
		placeholder: {
			name: 'Ingrese el nombre del tipo',
			axisCount: 'Seleccione la cantidad de ejes',
			upMode: 'Seleccione el modo ascendente'
		}
	},
	table: {
		id: 'ID',
		orgId: 'Organización',
		name: 'Nombre del Tipo',
		icon: 'Icono',
		axisCount: 'Cantidad de Ejes',
		upMode: 'Modo Ascendente',
                sysEig: 'Valores característicos',
		sysWave: 'Forma de Onda'
	},
	dialog: {
		add: 'Agregar',
		edit: 'Editar',
		cancel: 'Cancelar',
		confirm: 'Confirmar'
	},
	widgetForm: {
		name: 'Nombre del Tipo',
		orgId: 'Organización',
		icon: 'Icono',
		upMode: 'Modo Ascendente',
                characters: 'Código de función del valor característico',
		accelerate: 'Código de Función de Dominio de Tiempo',
                sysEig: 'Valores característicos',
		sysWave: 'Tipo de Forma de Onda',
		toolTypeId: 'Tipo de Herramienta de Diagnóstico',
		axisCount: 'Cantidad de Ejes',
		gridLayout: 'Diseño de Cuadrícula',
		requiredFieldCannotBeEmpty: 'El campo obligatorio no puede estar vacío',
		placeholder: {
			name: 'Seleccione el nombre del tipo',
			orgId: 'Seleccione la organización',
			icon: 'Seleccione el icono',
			upMode: 'Seleccione el modo ascendente',
                        characters: 'Ingrese el código de función del valor característico',
			accelerate: 'Ingrese el código de función de dominio de tiempo',
			toolTypeId: 'Seleccione el tipo de herramienta de diagnóstico',
			axisCount: 'Seleccione la cantidad de ejes'
		}
	}
}
